<script setup>

import Loading from 'vue-loading-overlay';
import {useCross} from "@/v2/hooks/cross";
import {LoadingMaskModeEnum, LoadingMaskSizeEnum} from "@/v2/enumerate/component/loading";

const {
  isLoadingMask
} = useCross()

/**
 * 傳入 - 參數
 */
const props = defineProps({
    mode: { type: null, required: false, default: LoadingMaskModeEnum.FULL },
    color: { type: String, required: false, default: '#DDA026' },
    backgroundColor: { type: String, required: false, default: '#FFF' },
    opacity: { type: Number, required: false, default: 0.3 },
    size: { type: null, required: false, default: LoadingMaskSizeEnum.LARGE },
    lockScroll: { type: Boolean, required: false, default: false },
    fullPage: { type: Boolean, required: false, default: false }
  })

</script>

<template>
  <div class="vl-parent">
    <loading v-if="props.mode === LoadingMaskModeEnum.FULL"
             v-model:active="isLoadingMask"
             :opacity="props.opacity"
             :color="props.color"
             :background-color="props.backgroundColor"
             :lock-scroll="true"
             :is-full-page="true" />
    <loading v-else-if="props.mode === LoadingMaskModeEnum.MANUAL"
             v-model:active="isLoadingMask"
             :width="props.size"
             :height="props.size"
             :opacity="props.opacity"
             :color="props.color"
             :background-color="props.backgroundColor"
             :lock-scroll="props.lockScroll"
             :is-full-page="props.fullPage" />
    <loading v-else
             active
             :width="props.size"
             :height="props.size"
             :color="props.color"
             :background-color="props.backgroundColor"
             :opacity="props.opacity"
             :lock-scroll="props.lockScroll"
             :is-full-page="props.fullPage" />
  </div>
</template>